// @flow
import * as React from 'react';
import { withLeaflet } from 'react-leaflet';
import type { LeafletContext } from 'react-leaflet/lib/types';
import { highlightFiberCircuit } from 'esm-web-pro/containers/pages/network/highlight';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import useHighlightFiber from 'esm-web-pro/containers/pages/network/objects/fiber/useHighlightFiber';
import UseHighlightPoint from 'esm-web-pro/hooks/useHighlightPoint';
import type { FiberDetailedRepresentation } from 'esm-web-pro/types/networks';


export const numberPointsCallbacksFiber = (fiber: Object) => {
    const {
        start_container_point: containerStartPoint, end_container_point: containerEndPoint,
    } = fiber.container;

    const startPointCoords = containerStartPoint.coordinates.coordinates;
    const endPointCoords = containerEndPoint.coordinates.coordinates;

    let startNumber = containerStartPoint.sequence;
    if (containerStartPoint.type === 'pop' && containerStartPoint.alias) {
        startNumber = containerStartPoint.alias;
    }
    let endNumber = containerEndPoint.sequence;
    if (containerEndPoint.type === 'pop' && containerEndPoint.alias) {
        endNumber = containerEndPoint.alias;
    }
    return [UseHighlightPoint(startPointCoords, startNumber),
        UseHighlightPoint(endPointCoords, endNumber)];
};

type Props = {
    fiber: FiberDetailedRepresentation,
    editor: BaseEditor,
    children: (handleView: Function) => React.Node,

    leaflet: LeafletContext,
};

const MapFiber = (props: Props) => {
    const {
        fiber, editor, children, leaflet: { map },
    } = props;

    const { circuit_path: fibersPaths } = fiber;

    const [circuitPaths, setPath] = React.useState([]);
    const [fiberCallbacks, setCallback] = React.useState([]);
    const [highlightFunction, highlightCleanUp] = useHighlightFiber();

    React.useEffect(() => {
        editor.unregisterAllLoadingCallback();
        const [fibersCallbacks, circuitPath] = highlightFiberCircuit(fibersPaths, fiber, map, highlightFunction);
        if (map) {
            map.highlightedGeometry = {
                bounds: circuitPath, center: null,
            };
            map.panInsideBounds(circuitPath);
        }
        editor.registerMultipleLoadingCallbacks(fibersCallbacks);
        editor.reloadFeatures();
        setPath(circuitPath);
        setCallback(fibersCallbacks);
        return () => {
            editor.unregisterAllLoadingCallback();
        };
    }, []);

    const handleView = () => {
        editor.unregisterAllLoadingCallback();
        if (map) {
            map.highlightedGeometry = {
                bounds: circuitPaths, center: null,
            };
            map.panInsideBounds(circuitPaths);
        }
        editor.registerMultipleLoadingCallbacks(fiberCallbacks);
        editor.reloadFeatures();
    };

    return children(handleView);
};

export default withLeaflet(MapFiber);
